/**
 * useAutoOpenOnDragOver — auto-open zwiniętego kontenera (panel akordeonu / step / …)
 * podczas drag-over po `delayMs` (default 500ms).
 *
 * F12.N pakiet B Sub-tura 4. Wzorzec SellCall / Notion / Trello: gdy admin trzyma
 * pole nad zwiniętym panelem akordeonu, panel rozwija się sam — admin nie musi
 * przerywać gestu by go najpierw kliknąć.
 *
 * Pure hook bez dnd-kit dependency — `isOver` ma być przekazany przez parent
 * z `useDroppable.isOver` (lub `useSortable.isOver`). Hook obsługuje setTimeout
 * + cleanup z useEffect, nic więcej.
 *
 * Behavior:
 *  - isOver=false → nic
 *  - isOver=true + isOpen=true → nic (już rozwinięty)
 *  - isOver=true + isOpen=false → schedule `onOpen` za `delayMs`
 *  - isOver flipuje na false PRZED wygaśnięciem → timer wyczyszczony (cleanup)
 *  - unmount → cleanup
 */

import { useEffect } from 'react';

export function useAutoOpenOnDragOver(
  isOver: boolean,
  isOpen: boolean,
  onOpen: () => void,
  delayMs: number = 500,
): void {
  useEffect(() => {
    if (!isOver || isOpen) return;
    const timer = setTimeout(onOpen, delayMs);
    return () => clearTimeout(timer);
  }, [isOver, isOpen, onOpen, delayMs]);
}
